import { render, staticRenderFns } from "./xszp.vue?vue&type=template&id=4bb9846a&"
import script from "./xszp.vue?vue&type=script&lang=js&"
export * from "./xszp.vue?vue&type=script&lang=js&"
import style0 from "./xszp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports